import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Mission from './components/Mission';
import Projects from './components/Projects';
import WebsiteDesign from './components/WebsiteDesign';
import Process from './components/Process';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const hash = window.location.hash;
    if (hash === '#privacy') {
      setCurrentPage('privacy');
    } else {
      setCurrentPage('home');
    }
  }, []);

  const handleNavigation = (page: string) => {
    setCurrentPage(page);
    if (page === 'privacy') {
      window.history.pushState({}, '', '#privacy');
    } else {
      window.history.pushState({}, '', '#');
    }
  };

  if (currentPage === 'privacy') {
    return (
      <div className="App">
        <Header />
        <PrivacyPolicy onBackToHome={() => handleNavigation('home')} />
        <Contact onPrivacyClick={() => handleNavigation('privacy')} />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <Hero />
      <WebsiteDesign />
      <Projects />
      <Mission />
      <Process />
      <Contact onPrivacyClick={() => handleNavigation('privacy')} />
    </div>
  );
}

export default App;
